import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, FormCheck, Button, Alert} from "react-bootstrap";

import { trataCpo, setMemoria } from "./../../tools/auxiliar";
import api from "../../services/api";
import "./styles.css";

export default function ParticipanteConfirma({ history }) {
    const [token, setToken] = useState([]);
    const [pessoa, setPessoa] = useState([]);
    const [chave, setChave] = useState("");
    const [email, setEmail]= useState('');
    const [senha, setSenha]= useState('');
    const [receberEmail, setReceberEmail]= useState(true);
    const [confirmar, setConfirmar]= useState('');
    const { token_id } = useParams();
    const [idToken, setIdToken] = useState(token_id);
    const idAudiencia = localStorage.getItem("idAudiencia");
    const [mensagem, setMensagem]= useState("");
    const [tipoMensagem, setTipoMensagem] = useState("danger");

    let idPessoa = "0";
    if (token && token.length>0){
      idPessoa=token[0].ID_PESSOA;
    }
    useEffect(() => { 
      async function loadToken() {
        if (!isNaN(idToken) && idToken && idToken !== "0") {
          const response = await api.get(`/api/token/${idToken}`);
          setToken(response.data);
        }
      }
      loadToken();
    }, [idToken]);

    useEffect(() => {
      async function loadPessoa() {
        if (idPessoa !== "0") {
          const response = await api.get(`/api/pessoa/${idPessoa}/pessoa`);
          setPessoa(response.data[0]);
        }
      }
      loadPessoa();
    }, [idPessoa]);

    useEffect(() => {
      async function loadChave() {
        const sistema = '***consulta_publica***';
        const response = await api.get('/api/configuracao', {
          headers: { sistema }
        });
        setChave(response.data[0].NO_EMAIL);
      }
      loadChave();
    }, [idToken]);

    function handleCancelar() {
      if (idAudiencia) {
        history.push(`/Consulta/${idAudiencia}`);       
      } else {
        history.push(`/`);
      }
    }

    function handleAEnviarNovo() {
      if (criticaDados()){
        salvaDados();
      }
    }

    function criticaDados() {
      setTipoMensagem("danger")
      setMensagem([]);
      var msg = "";
      if (idToken.length<1){
        msg +="Informe o n° recebido via e-mail; ";
      }
      if (!email || email.length < 4){
        msg +="E-mail é obrigatório; "
      }
      if (senha.length<8){
        msg +="Senha deve ter 8 caracteres ou mais; ";
      }
      if (senha !== confirmar){
        msg +="Senha não confere;";
      }
      if (pessoa.length===0) {
        msg +="Participante inválido";        
      } else {
        if (pessoa && pessoa.NO_EMAIL.toLowerCase() !== email.toLowerCase()){
          msg +="Participante inválido";
        }
      }

      if (msg){
        setMensagem(msg);
        return false;
      }
      else {
        return true;
      }
    }
    async function salvaDados() {
      setMemoria("","",false);
      const senhaTratada = trataCpo(senha, chave);
      var receberEmailAux = "N";
      if (receberEmail){
        receberEmailAux = "S";
      }
      const data = { 
        'idPessoa': idPessoa,
        'idToken': idToken, 
        'senha': senhaTratada,
        'receberEmail': receberEmailAux
      };
      await api.put(
        `/api/pessoa`,
        data);
      setMemoria(pessoa.NO_PESSOA, email, true);
      if (idAudiencia) {
        window.location.href= `/Consulta/${idAudiencia}`;       
      } else {
        window.location.href= "/";
      }
    }
    return (
      <>
        <Container>
          <Row>
            <Col sm={12}>
              <div className="voltar">
                <a href={idAudiencia? `/Consulta/${idAudiencia}`: "/"}>voltar</a>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="quadro">
                <h3>
                  Confirmação de cadastro de participante
                </h3>
              </div>
            </Col>
          </Row>
              <form id="formContribuinte">
                <div className="quadro">
                  <Row>
                    <Col sm="2">
                      <label htmlFor="token">N° recebido:*</label>
                    </Col>
                    <Col sm="10">
                      <input
                        id="token"
                        className={idToken !== "" ? "Normal" : "Requerido"}
                        type="text"
                        placeholder="N° recebido via e-mail"
                        onBlur={e => {
                          const cpo = document.getElementById("token").value;
                          if (cpo.length > 1)
                            document.getElementById("token").className = "Normal";
                          else
                            document.getElementById("token").className = "Requerido";
                        }}
                        value={idToken}
                        onChange={event => setIdToken(event.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2">
                      <label htmlFor="Email">E-mail:*</label>
                    </Col>
                    <Col sm="10">
                      <input
                        id="Email"
                        className="Requerido"
                        type="email"
                        placeholder="E-mail"
                        onBlur={e => {
                          if (email.length > 0)
                            document.getElementById("Email").className = "Normal";
                          else
                            document.getElementById("Email").className = "Requerido";
                        }}
                        value={email}
                        onChange={event => setEmail(event.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                  <Col sm="2">
                      <label htmlFor="senhaNovo">Senha:*</label>
                    </Col>
                    <Col sm="4">
                      <input
                        type="password"
                        id="senhaNovo"
                        className="Requerido"
                        placeholder="Informe sua senha"
                        value={senha}
                        onChange={event =>setSenha(event.target.value)}
                        autoComplete="password"
                      />
                    </Col>
                    <Col sm="2">
                      <label htmlFor="confirmar">Confirmar senha:*</label>
                    </Col>
                    <Col sm="4">
                      <input
                        type="password"
                        id="confirmar"
                        className="Requerido"
                        placeholder="Confirme a sua senha"
                        value={confirmar}
                        onChange={event =>setConfirmar(event.target.value)}
                        autoComplete="password"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <FormCheck>
                        <FormCheck.Input type={'checkbox'} 
                          className="receberEmail"
                          defaultChecked={receberEmail} 
                          onChange={event =>setReceberEmail(!receberEmail)}/>
                        <FormCheck.Label>Receber informações sobre Participações Sociais da ANA?</FormCheck.Label>
                      </FormCheck>
                    </Col>
                  </Row>
                  <Row className={mensagem ? "mostrar" : "naoMostrar"}>
                    <Col sm="12">
                      <Alert variant={tipoMensagem}>
                          {mensagem}
                      </Alert>
                    </Col>
                  </Row>
                  <Row>
                  <Col sm={12} className="linhaBotao">
                    <Button variant="secondary" onClick={handleCancelar}>Cancelar</Button>
                    <Button variant="success" onClick={handleAEnviarNovo}>Enviar</Button>
                  </Col>
                  </Row>
                  <Row>
                    <Col sm="12" className="observacao">
                      Os itens marcados com <strong>*</strong> (asterisco) são obrigatórios!
                    </Col>
                  </Row>
                </div>
            </form>
        </Container>
      </>
    );
}